// @flow

import type { Merchant } from '@tectonics/prs/merchant/types';
import { getMerchantConfig } from '../get-merchant-config';

const SHAPE_TO_RADIUS = {
  none: '0px',
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  pill: '999px',
};

export function getPaymentPageButtonShape(merchant: Merchant): string | null {
  const merchantConfig = getMerchantConfig(merchant);

  if (!merchantConfig || !merchantConfig.payment_page_customization) {
    return null;
  }

  const customization = merchantConfig.payment_page_customization;

  if (!customization.shapes || !customization.shapes.button) {
    return null;
  }

  const shapeToken = customization.shapes.button;
  return SHAPE_TO_RADIUS[shapeToken] || null;
}
